import React from 'react'
export const CheckBox = (props) => {
    return (
        <div className={props.className}>
            <input type="checkbox" onChange={props.onChange} name={props.name} id={props.id} {...props.other} />
            <label htmlFor={props.id}>{props.labelText}</label>
        </div>
    )
}